import { httpClient } from "./httpClient";

const getManagerSetting = () => {
  return httpClient.get("manager-setting");
};

const updateManagerSetting = (idManagerSetting, formData) => {
  return httpClient.put(`manager-setting/${idManagerSetting}`, formData);
};

const getManager = () => {
  return httpClient.get("v2/manager");
};

const addManager = (formData) => {
  return httpClient.post(`/manager`, formData);
};

const updateManager = (idEmployees, formData) => {
  return httpClient.put(`/manager/${idEmployees}`, formData);
};

const getManagerGroup = () => {
  return httpClient.get(`/manager-group`);
};

const addManagerGroup = (formData) => {
  return httpClient.post(`/manager-group`, formData);
};

const updateManagerGroup = (idManagerGroup, formData) => {
  return httpClient.put(`/manager-group/${idManagerGroup}`, formData);
};

const deleteManagerGroup = (idManagerGroup) => {
  return httpClient.delete(`/manager-group/${idManagerGroup}`);
};

export default {
  getManagerSetting,
  updateManagerSetting,
  getManager,
  addManager,
  updateManager,
  getManagerGroup,
  addManagerGroup,
  updateManagerGroup,
  deleteManagerGroup,
};
